import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MomentModule } from 'ngx-moment';

import { FormFieldsModule } from 'app/form-fields/form-fields.module';
import { SegmentModule } from 'app/segment/segment.module';
import { ChartUtilsService } from 'app/shared/service/chart-utils.service';
import { SampleChartDataService } from 'app/shared/service/sample-chart-data.service';
import { SharedModule } from 'app/shared/shared.module';

import { AnalyticsRoutingModule } from './analytics-routing.module';
import { AnalyticsService } from './analytics.service';
import { ChartViewModalFiltersComponent } from './charts/chart-view/chart-view-modal/chart-view-modal-filters/chart-view-modal-filters.component';
import { ChartViewModalComponent } from './charts/chart-view/chart-view-modal/chart-view-modal.component';
import { ChartViewComponent } from './charts/chart-view/chart-view.component';
import { ChartsCreationWizardComponent } from './charts/charts-list/charts-creation-wizard/charts-creation-wizard.component';
import { ChartsGridComponent } from './charts/charts-list/charts-grid/charts-grid.component';
import { ChartsListToolbarComponent } from './charts/charts-list/charts-list-toolbar/charts-list-toolbar.component';
import { ChartsListComponent } from './charts/charts-list/charts-list.component';
import { ChartsRegisterComponent } from './charts/charts-list/charts-register/charts-register.component';
import { FrequencyBarChartDataParser } from './charts/frequency-chart/frequency-bar-chart-data-parser';
import { FrequencyChartDataService } from './charts/frequency-chart/frequency-chart-data.service';
import { FrequencyChartComponent } from './charts/frequency-chart/frequency-chart.component';
import { FrequencyCumulativeBarChartDataParser } from './charts/frequency-chart/frequency-cumulative-bar-chart-data-parser';
import { FrequencyChartSettingsComponent } from './charts/frequency-chart/settings/frequency-chart-settings.component';
import { FrequencyChartThumbnailComponent } from './charts/frequency-chart/thumbnail/frequency-chart-thumbnail.component';
import { AreaChartDataParser } from './charts/quantity-chart/area-chart-data-parser';
import { BarChartDataParser } from './charts/quantity-chart/bar-chart-data-parser';
import { ComboChartComponent } from './charts/quantity-chart/combo-chart/combo-chart.component';
import { QuantityChartDataService } from './charts/quantity-chart/quantity-chart-data.service';
import { QuantityChartComponent } from './charts/quantity-chart/quantity-chart.component';
import { ChartViewModalSettingsComponent } from './charts/quantity-chart/settings/quantity-chart-settings.component';
import { QuantityChartThumbnailComponent } from './charts/quantity-chart/thumbnail/quantity-chart-thumbnail.component';
import { RatioChartComponent } from './charts/ratio-chart/ratio-chart.component';
import { RatioChartSettingsComponent } from './charts/ratio-chart/settings/ratio-chart-settings.component';
import { RatioChartThumbnailComponent } from './charts/ratio-chart/thumbnail/ratio-chart-thumbnail.component';
import { AddEditDashboardComponent } from './dashboards/add-edit-dashboard/add-edit-dashboard.component';
import { DashboardsGridComponent } from './dashboards/dashboards-grid/dashboards-grid.component';
import { CompanyDashboardsListComponent } from './dashboards/dashboards-list/company-dashboards-list.component';
import { TeamDashboardsListComponent } from './dashboards/dashboards-list/team-dashboards-list.component';
import { EditCompanyDashboardModalComponent } from './dashboards/edit-dashboard-modal/edit-company-dashboard-modal.component';
import { EditTeamDashboardModalComponent } from './dashboards/edit-dashboard-modal/edit-team-dashboard-modal.component';
import { TemplatesModule } from '../apps/templates.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    MomentModule,
    SharedModule,
    AnalyticsRoutingModule,
    TemplatesModule,
    SegmentModule,
    NgxChartsModule,
    FormFieldsModule,
  ],

  declarations: [
    TeamDashboardsListComponent,
    CompanyDashboardsListComponent,
    DashboardsGridComponent,
    ChartsListComponent,
    ChartsGridComponent,
    AddEditDashboardComponent,
    EditTeamDashboardModalComponent,
    EditCompanyDashboardModalComponent,
    ChartViewComponent,
    ChartViewModalComponent,
    QuantityChartThumbnailComponent,
    FrequencyChartThumbnailComponent,
    ChartsRegisterComponent,
    ChartsListToolbarComponent,
    ChartViewModalSettingsComponent,
    ChartViewModalFiltersComponent,
    FrequencyChartSettingsComponent,
    QuantityChartComponent,
    FrequencyChartComponent,
    ComboChartComponent,
    ChartsCreationWizardComponent,
    RatioChartComponent,
    RatioChartSettingsComponent,
    RatioChartThumbnailComponent,
  ],
  providers: [
    AnalyticsService,
    ChartUtilsService,
    BarChartDataParser,
    AreaChartDataParser,
    FrequencyBarChartDataParser,
    FrequencyCumulativeBarChartDataParser,
    QuantityChartDataService,
    FrequencyChartDataService,
    SampleChartDataService,
  ],
  exports: [],
})
export class AnalyticsModule {}
